/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ViewRoute extends Route {
  // Services
  @service
  store;

  model() {
    let templateSet = this.modelFor('people.schema.template');
    return hash({
      templateSet,
      groups: this.store.query('people-schema/group', {
        setId: templateSet.id,
      }),
      fields: this.store.query('people-schema/field', {
        setId: templateSet.id,
      }),
    });
  }
}
